import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'

// Interface for the User
interface IUserState {
	isLoggedIn: boolean
	loginChecked: boolean
	dataLoadRequestFinished: boolean // flag indicating that the users data request has finished
	chatDataLoaded: boolean
	showNewPost: boolean
}

// Initial state
const initialState: IUserState = {
	isLoggedIn: false,
	loginChecked: false,
	dataLoadRequestFinished: false,
	chatDataLoaded: false,
	showNewPost: false
}

// Slice definition
export const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		setLoggedIn: (state, action: PayloadAction<boolean>) => {
			state.isLoggedIn = action.payload
		},
		setLoggedInChecked: (state, action: PayloadAction<boolean>) => {
			state.loginChecked = action.payload
		},
		setDataLoadRequestFinished: (state, action: PayloadAction<boolean>) => {
			state.dataLoadRequestFinished = action.payload
		},
		setChatDataLoaded: (state, action: PayloadAction<boolean>) => {
			state.chatDataLoaded = action.payload
		},
		setShowNewPost: (state, action: PayloadAction<boolean>) => {
			state.showNewPost = action.payload
		}
	}
})

// Export actions
export const { setLoggedIn, setLoggedInChecked, setDataLoadRequestFinished, setChatDataLoaded, setShowNewPost } = userSlice.actions

// Export selectors
// export const isLoggedIn = (state: RootState) => state.user.isLoggedIn
// export const loginChecked = (state: RootState) => state.user.loginChecked
// export const dataLoadRequestFinished = (state: RootState) => state.user.dataLoadRequestFinished
// export const chatDataLoaded = (state: RootState) => state.user.chatDataLoaded

// Export the reducer
export default userSlice.reducer
